module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-Hant":{"modified":"已編輯"},"en":{"modified":"modified"}}')
  delete Component.options._Ctor
}
